module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    class: {
      allmapFixed: _vm.attendanceType
    }
  }, [_c('div', {
    ref: "allmap",
    style: ({
      height: _vm.mapHeight + 'px'
    }),
    attrs: {
      "id": "allmap"
    }
  })]), _vm._v(" "), _c('div', {
    style: ({
      paddingTop: _vm.attendanceType ? '250px' : '0px'
    })
  }, [_c('div', {
    staticClass: "attendanceText"
  }, [_vm._v("考勤打卡")]), _vm._v(" "), _c('group', [_c('cell-box', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.popupData.length > 2),
      expression: "this.popupData.length > 2"
    }],
    attrs: {
      "is-link": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.changeArea()
      }
    }
  }, [_c('flexbox', [_c('flexbox-item', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "flex-demo home-list-title"
  }, [_c('p', {
    staticClass: "item-p"
  }, [_vm._v("考勤地点")])])]), _vm._v(" "), _c('flexbox-item', [_c('div', {
    staticClass: "flex-demo home-list-date"
  }, [_vm._v(_vm._s(_vm.popupData))])])], 1)], 1)], 1), _vm._v(" "), (_vm.attendanceType) ? _c('group', {
    staticClass: "loactionAttendance"
  }, _vm._l((_vm.attendanceNearArea), function(item) {
    return _c('cell', {
      key: item,
      attrs: {
        "title": item.title
      },
      nativeOn: {
        "click": function($event) {
          _vm.selectThisArea(item)
        }
      }
    }, [_c('div', [_c('svg', {
      staticClass: "vux-x-icon vux-x-icon-ios-checkmark-empty",
      style: ({
        opacity: item.select ? '1' : '0'
      }),
      attrs: {
        "type": "ios-checkmark-empty",
        "size": "30",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "30",
        "height": "30",
        "viewBox": "0 0 512 512"
      }
    }, [_c('path', {
      attrs: {
        "d": "M223.9 329.7c-2.4 2.4-5.8 4.4-8.8 4.4s-6.4-2.1-8.9-4.5l-56-56 17.8-17.8 47.2 47.2L340 177.3l17.5 18.1-133.6 134.3z"
      }
    })])])])
  })) : _vm._e(), _vm._v(" "), (_vm.attendanceType) ? _c('div', {
    staticStyle: {
      "height": "45px"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "attendanceFooter"
  }, [_c('flexbox', [_c('flexbox-item', [_c('div', {
    staticClass: "attendanceSelectWrapper",
    on: {
      "click": function($event) {
        _vm.reGetLocation()
      }
    }
  }, [_c('img', {
    staticClass: "attendanceIcon",
    attrs: {
      "src": require("../../assets/icon/address.png")
    }
  }), _vm._v("\n          重新定位\n        ")])]), _vm._v(" "), _c('flexbox-item', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('x-button', {
    attrs: {
      "mini": "",
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        _vm.appSign()
      }
    }
  }, [_vm._v("打卡")]), _vm._v(" "), _c('x-button', {
    attrs: {
      "mini": "",
      "link": {
        path: '/attendanceCount'
      }
    }
  }, [_vm._v("记录")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }]
  }, [_c('popup', {
    model: {
      value: (_vm.areaCtrl),
      callback: function($$v) {
        _vm.areaCtrl = $$v
      },
      expression: "areaCtrl"
    }
  }, [_c('popup-header', {
    attrs: {
      "title": "选择附近的考勤地点",
      "show-bottom-border": false
    },
    on: {
      "on-click-left": function($event) {
        _vm.areaCtrl = false
      },
      "on-click-right": function($event) {
        _vm.areaCtrl = false
      }
    }
  }), _vm._v(" "), _c('group', {
    attrs: {
      "gutter": "0"
    }
  }, [_c('radio', {
    attrs: {
      "options": _vm.nearbyAddress,
      "title": _vm.nearbyAddress
    },
    on: {
      "on-change": _vm.changePlace
    },
    model: {
      value: (_vm.popupData),
      callback: function($$v) {
        _vm.popupData = $$v
      },
      expression: "popupData"
    }
  })], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4278e80e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/attendance/Attendance-compoment.vue
// module id = gQ5+
// module chunks = 0